<template>
    <div
        v-if="visible"
        id="progressbar-container"
        class="fixed-bottom bg-secondary"
        :class="classstr"
    >
        <div
            id="progressbar-indicator"
            class="bg-primary"
            :class="innerclass"
            :style="width"
        ></div>
        <div
            id="progressbar-description"
            class="text-center text-white"
        >
            {{ current }} / {{ max }}
        </div>
    </div>
</template>

<style scoped>
#progressbar-container {
    width: 100%;
    height: 1.5rem;
    position: relative;
}

#progressbar-indicator {
    position: absolute;
    transition: all 0.3s ease-in-out;
    bottom: 0;
    left: 0;
    height: 1.5rem;
}

#progressbar-description {
    position: absolute;
    bottom: 0;
    width: 100%;
}

.fixed-bottom {
    z-index: 1 !important;
}
</style>

<script>
export default {
    name: "Progressbar",
    props: {
        class: {
            type: String,
        },
        current: {
            type: Number,
        },
        innerclass: {
            type: String,
        },
        max: {
            type: Number,
        },
        visible: {
            type: Boolean,
        },
    },
    computed: {
        classstr() {
            return this.class;
        },
        percentage() {
            return (this.current / this.max) * 100;
        },
        width() {
            return "width: " + this.percentage + "%;";
        },
    },
};
</script>
